import { firestore } from "../firebase"

export const fetchText = async () => {
	return new Promise(async (resolve, reject) => {
		try {
			const snapshot = await firestore.collection("text").doc("main").get()

			const snapshotsData = snapshot.data()

			resolve(snapshotsData)
		} catch (error) {
			console.error(error)
			reject(error)
		}
	})
}

export const getTexts = state => {
	return state.text
}

export const getText = (state, id) => {
	return state.text[id]
}

const textReducer = (state = {}, action) => {
	const { type, text } = action

	switch (type) {
		case "SET_TEXT":
			return text

		default:
			return state
	}
}

export default textReducer
